export default class TmmCards {
  constructor(cards) {
    this.cards = cards;

    if (this.cards.length) {
      this.events();
    }
  }

  events() {
    this.cards.forEach((card) => {
      card.addEventListener('click', () => this.showCard(card));
    });
  }

  showCard(card) {
    this.hideAllCards();
    card.classList.add('show-card');
  }

  hideAllCards() {
    this.cards.forEach((card) => card.classList.remove('show-card'));
  }
}
